export default "__VITE_ASSET__lBuuqTl6cGg_H7vrdNQ7tQ__"